import { GenericService } from '../GenericService'

class CompanyUserService extends GenericService {
    constructor() {
        super('/api/admin/companyUsers')
    }

    getSingleRecord = (id) =>
        this.get('/api/admin/companyUsers/getSingle/' + id)
}

export default new CompanyUserService()
